<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { commonMenuList } from '@/http/url';
export default {
  name: 'App',
  mounted() {
    this.linkTab();
    this.getMenuList();
  },
  methods: {
    async getMenuList() {
      let { data, status, msg } = await commonMenuList()
      if (status !== 200) return
      this.$utils.setLocal('menuList', data.children);
      let menuList = data.children
      let arr = this.$utils.getMenuArr("关于我们", this.$utils.getLocal('menuList'))
      arr.forEach(item => {
        if (item.menuName === "联系我们") {
          menuList.push(item)
        }
      })
      this.$utils.setLocal('menuList', menuList);
    },
    //  判断打开方式
    linkTab() {
      let goUrl = this.isMobile();
      if (goUrl === 0) {
        //PC端地址
        // location = "http://www.ahsjgs.com/";
        // location = "http://47.103.36.64:3000/";
      }
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag ? 1 : 0;
    },
  }

}
</script>

<style>
html, body {
  width: 100%;
  height: 100%;
  margin: 0;
}

#app {
  background-color: white;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
